import { useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from "@mui/material";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import PricingMenu from "./PricingMenu";
import TodayIcon from '@mui/icons-material/Today';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import CalendarPage from "./Calendar/CalendarPage";
import RatePlansPage from "./RatePlans/RatePlansPage";
import RatesPage from "./Rates/RatesPage";
import PriceModifiersPage from './PriceModifiers/PriceModifiersPage';

export const pricingSubPages = [
    {
        id: 1,
        name: "calendar",
        displayName: "Calendar",
        icon: <TodayIcon />
    }, {
        id: 2,
        name: "rate-plans",
        displayName: "Rate Plans",
        icon: <CorporateFareIcon />
    },
    {
        id: 3,
        name: "rates",
        displayName: "Rates",
        icon: <AttachMoneyIcon />
    },
    {
        id: 4,
        name: "price-modifiers",
        displayName: "Price Modifiers",
        icon: <PriceChangeIcon />
    }
]

const AvailabilityAndPricingRouter = (props) => {
    return <Routes>
        <Route exact path="/" element={<Navigate to="calendar" />} />
        <Route path=":pricingSubPageName/*" element={<AvailabilityAndPricingPage {...props} />} />
    </Routes>
}

const AvailabilityAndPricingPage = (props) => {
    const { pricingSubPageName } = useParams();

    const getSubPage = () => {
        switch (pricingSubPageName) {
            case "rate-plans":
                return RatePlansPage;
            case "rates":
                return RatesPage;
            case "price-modifiers":
                return PriceModifiersPage;
            case "calendar":
            default:
                return CalendarPage;
        }
    }

    const SubPage = getSubPage();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return <Box
        id="pricing"
        sx={{
            display: "flex",
            alignItems: "flex-start",
            flexGrow: 1,
            flexDirection: isMobile ? "column" : "row"
        }}>
        {!isMobile && <PricingMenu value={pricingSubPageName} />}
        <Box id="pricingContent" sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: 'auto', position: 'relative' }}>
            <SubPage />
        </Box>
        {isMobile && <PricingMenu value={pricingSubPageName} mobile />}
    </Box>
}

export default AvailabilityAndPricingRouter;